import { useAuth0 } from '@auth0/auth0-react';
import { Menu, OpenInNew } from '@mui/icons-material';
import {
    Box,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    Typography,
} from '@mui/material';
import CreateProjectButton from 'components/Buttons/CreateProjectButton';
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import DrawerToggleMenu from './DrawerToggleSubMenu';
import { INav } from './Navbar';
import NavbarStyles from './Navbar.styles';

const NavDrawer = (props: INav) => {
    const { isAuthenticated } = useAuth0();
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <Toolbar>
            <Box
                component={NavLink}
                to="/"
                sx={[NavbarStyles.logoContainer, { flexGrow: 1, justifyContent: 'flex-end' }]}
            >
                <img style={NavbarStyles.logo as any} alt="neurosynth compose logo" src="/static/synth.png" />
                <Typography sx={NavbarStyles.logoText}>neurosynth compose</Typography>
            </Box>
            <Box sx={{ flexGrow: 1, justifyContent: 'flex-end', display: 'flex' }}>
                <IconButton onClick={() => setIsOpen(true)}>
                    <Menu />
                </IconButton>
            </Box>
            <Drawer anchor="right" open={isOpen} onClose={() => setIsOpen(false)}>
                <List sx={{ width: '260px' }}>
                    {isAuthenticated && (
                        <>
                            <ListItem>
                                <ListItemButton sx={{ padding: 0 }}>
                                    <CreateProjectButton buttonProps={{ sx: { width: '100%', fontSize: '1rem' } }} />
                                </ListItemButton>
                            </ListItem>
                            <ListItem>
                                <ListItemButton onClick={() => navigate('/projects')}>
                                    <ListItemIcon />
                                    <ListItemText primary="MY PROJECTS" />
                                </ListItemButton>
                            </ListItem>
                        </>
                    )}
                    <DrawerToggleMenu labelText="EXPLORE">
                        <List>
                            <ListItem>
                                <ListItemButton onClick={() => navigate('/base-studies')}>
                                    <ListItemIcon />
                                    <ListItemText primary="STUDIES" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem>
                                <ListItemButton onClick={() => navigate('/meta-analyses')}>
                                    <ListItemIcon />
                                    <ListItemText primary="META-ANALYSES" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </DrawerToggleMenu>
                    <DrawerToggleMenu labelText="Help">
                        <List>
                            <ListItem>
                                <ListItemButton
                                    onClick={() => window.open('https://neurostuff.github.io/compose-docs/', '_blank')}
                                >
                                    <ListItemIcon />
                                    <ListItemText primaryTypographyProps={{ display: 'flex', alignItems: 'center' }}>
                                        Documentation <OpenInNew fontSize="small" sx={{ ml: 1 }} />
                                    </ListItemText>
                                </ListItemButton>
                            </ListItem>
                            <ListItem>
                                <ListItemButton onClick={() => navigate('/help')}>
                                    <ListItemIcon />
                                    <ListItemText primary="Get Help" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </DrawerToggleMenu>
                    {/* <ListItem>
                        <Button
                            sx={{ display: 'flex', padding: '8px 16px', width: '100%' }}
                            target="_blank"
                            rel="noreferrer"
                            href="https://neurostuff.github.io/neurostore/"
                        >
                            <ListItemIcon>
                                <OpenInNewIcon />
                            </ListItemIcon>
                            <ListItemText primary="DOCS" sx={{ color: 'black' }} />
                        </Button>
                    </ListItem> */}
                    <ListItem>
                        <ListItemButton
                            onClick={() => {
                                if (isAuthenticated) {
                                    props.onLogout();
                                } else {
                                    props.onLogin();
                                }
                            }}
                        >
                            <ListItemIcon />
                            <ListItemText
                                sx={{
                                    color: isAuthenticated ? '' : 'warning.dark',
                                }}
                                primary={isAuthenticated ? 'LOGOUT' : 'SIGN IN/SIGN UP'}
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Drawer>
        </Toolbar>
    );
};

export default NavDrawer;
